export default __webpack_public_path__ + "static/media/Gents-Glamor3.a772ac7d.png";